import script from "./tableColumnVir.vue?vue&type=script&lang=js"
export * from "./tableColumnVir.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__